import { render } from "./BackToStudentUiButton.vue?vue&type=template&id=84767768&scoped=true"
import script from "./BackToStudentUiButton.vue?vue&type=script&lang=js"
export * from "./BackToStudentUiButton.vue?vue&type=script&lang=js"

import "./BackToStudentUiButton.vue?vue&type=style&index=0&id=84767768&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84767768"]])

export default __exports__